// extracted by mini-css-extract-plugin
module.exports = {"timed_offers_page":"TimedOffers_timed_offers_page__3W8p4","loading_screen":"TimedOffers_loading_screen__3pOL-","loading_text":"TimedOffers_loading_text__3uveP"};